/**
 * 能流图接口
 */
import Axios from '@/components/api/axios.js'

export default {
	FlowLossList:(chartId,type,startTime, endTime,success,failure) => {
		Axios.post('/energy/getEnergyFlowLossList.do', {
			chartId,type,startTime, endTime,
		}, success, failure)
	},
	getEnergyLossFlowByUnitId(unitId,success,failure) {
		Axios.post('/energy/getEnergyLossFlowByUnitId.do', {
			unitId
		},success,failure)
	},
	getEnergyFlowChart(chartId,startTime,endTime,energyType,success,failure) {
		Axios.post('/energy/getEnergyFlowChart.do',{
			chartId,startTime,endTime,energyType
		},success,failure)
	},
	/**
	 * 找单位下的能流图
	 * @param success
	 * @param failure
	 */
	getEnergyFlowChartsByUnitId(success,failure) {
	Axios.post('/energy/getEnergyFlowChartsByUnitId.do', {

	},success,failure)
	},
	getEnergyFlowLossList(chartId,success,failure) {
		Axios.post('/energy/getEnergyFlowLossList.do', {
			chartId
		},success,failure)
	},
	/*
	 * 获取能流图
	 */
	getEnergyFlowDiagram(unitId, beginTime, endTime, success, failure) {
		Axios.post('/energyFlow/getEnergyFlowDiagram.do', {
			unitId,
			beginTime,
			endTime
		}, success, failure)
	},
	/*
	 * 获取单位能流配置树
	 */
	getEnergyFlowConfigTree(unitId, success, failure) {
		Axios.post('/energyFlow/getEnergyFlowConfigTree.do', {
			unitId
		}, success, failure)
	},
	/*
	 * 添加能流图配置
	 */
	addEnergyFlowConfig(deviceNo, deviceName, parentNo, unitId, success, failure) {
		Axios.post('/energyFlow/addEnergyFlowConfig.do', {
			deviceNo,
			deviceName,
			parentNo,
			unitId
		}, success, failure)
	},
	/*
	 * 删除能流图配置（包括下级全部删除）
	 */
	deleteEnergyFlowConfig(deviceNo, success, failure) {
		Axios.post('/energyFlow/deleteEnergyFlowConfig.do', {
			deviceNo
		}, success, failure)
	},
	/*
	 * 虚拟设备树（没有根据用户过滤，慎用）
	 */
	getVirtualDeviceForEnergyFlowConfig(unitId, success, failure) {
		Axios.post('/energyFlow/getVirtualDeviceForEnergyFlowConfig.do', {
			unitId
		}, success, failure)
	},

}